import { createSlice } from '@reduxjs/toolkit';
import {
  changePasswordBuilder,
  createOrganizationMemberBuilder,
  createReviewBuilder,
  deleteOrganizationMemberBuilder,
  editOrganizationMemberBuilder,
  fetchAllOrganizationChattersBuilder,
  fetchAllOrganizationInfluencersBuilder,
  fetchAllOrganizationTeamLeadsBuilder,
  fetchInfluencerByIdBuilder,
  fetchInfluencesBuilder,
  fetchOrganizationMembersInfoBuilder,
  generateInfluencerPersonalityBuilder,
  uploadInfluencerVoiceBuilder,
  testInfluencerVoiceBuilder,
  saveInfluencerVoiceBuilder,
  editInfluencerPricingBuilder,
  uploadInfluencerQuestionnaireBuilder,
  refreshInfluencerFactsStatusBuilder,
  fetchReviewByIdBuilder,
  fetchReviewsBuilder,
  getOrganizationMemberByIdBuilder,
} from './builder';
import { LOGOUT } from '../../../utils/constants';

const INIT_STATE = {
  fetchInfluencersInfo: {
    pending: false,
    data: [],
    total: 0,
  },
  fetchOrganizationMembersInfo: {
    pending: false,
    data: [],
    total: 0,
  },
  fetchReviews: {
    pending: false,
    data: [],
  },
  influencerOptions: [],
  chattersOptions: [],
  teamLeadsOptions: [],
  selectedInfluencer: null,
  selectedReview: null,
  pending: {
    changePassword: false,
    fetchInfluencerById: false,
    createOrganizationMember: false,
    deleteOrganizationMember: false,
    getOrganizationMemberById: false,
    editOrganizationMember: false,
    createReview: false,
    fetchReviewById: false,
    generateInfluencerPersonality: false,
    uploadInfluencerVoice: false,
    testInfluencerVoice: false,
    saveInfluencerVoice: false,
    editInfluencerPricing: false,
    uploadInfluencerQuestionnaire: false,
  },
};

export const chatterSlice = createSlice({
  name: 'chatter',
  initialState: INIT_STATE,
  reducers: {
    setSelectedInfluencer: (state, { payload }) => {
      state.selectedInfluencer = payload;
    },
    setSelectedReview: (state, { payload }) => {
      state.selectedReview = payload;
    },
  },
  extraReducers: builder => {
    changePasswordBuilder(builder);
    fetchInfluencesBuilder(builder);
    fetchInfluencerByIdBuilder(builder);
    generateInfluencerPersonalityBuilder(builder);
    uploadInfluencerVoiceBuilder(builder);
    testInfluencerVoiceBuilder(builder);
    saveInfluencerVoiceBuilder(builder);
    editInfluencerPricingBuilder(builder);
    uploadInfluencerQuestionnaireBuilder(builder);
    refreshInfluencerFactsStatusBuilder(builder);
    fetchOrganizationMembersInfoBuilder(builder);
    fetchAllOrganizationInfluencersBuilder(builder);
    createOrganizationMemberBuilder(builder);
    fetchAllOrganizationChattersBuilder(builder);
    fetchAllOrganizationTeamLeadsBuilder(builder);
    deleteOrganizationMemberBuilder(builder);
    getOrganizationMemberByIdBuilder(builder);
    editOrganizationMemberBuilder(builder);
    createReviewBuilder(builder);
    fetchReviewsBuilder(builder);
    fetchReviewByIdBuilder(builder);
    builder.addCase(LOGOUT, () => ({ ...INIT_STATE }));
  },
});

export const { setSelectedInfluencer, setSelectedReview } = chatterSlice.actions;

export const selectChatterActionsPending = state => state.chatterInfo.pending;
export const selectFetchInfluencersInfo = state => state.chatterInfo.fetchInfluencersInfo;
export const selectFetchOrganizationMembersInfo = state => state.chatterInfo.fetchOrganizationMembersInfo;
export const selectFetchReviews = state => state.chatterInfo.fetchReviews;
export const selectSelectedInfluencer = state => state.chatterInfo.selectedInfluencer;
export const selectSelectedReview = state => state.chatterInfo.selectedReview;
export const selectInfluencerOptions = state => state.chatterInfo.influencerOptions;
export const selectChattersOptions = state => state.chatterInfo.chattersOptions;
export const selectTeamLeadsOptions = state => state.chatterInfo.teamLeadsOptions;

export default chatterSlice.reducer;
